import {
  PanelBody,
  TextControl,
  TextareaControl,
  ColorPalette,
  ToggleControl,
  Notice
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { t } from "drupal";
import { useState, useEffect, useCallback } from "@wordpress/element";
import { handleUrlChange2, sanitizeInput, sanitizeKeepHTML, isValidDomain } from '../utilities/helpers';




function ProfileSidePanel({
  profileName = '',
  title = '',
  content = '',
  link = '',
  linkText = '',
  ariaLabel = '',
  showLink = false,

  onChangeProfileName,
  onChangeTitle,
  onChangeContent,
  onChangeLink,
  onChangeLinkText,
  setAttributes
}) {

  const onChangeAriaLabel = (value) => setAttributes({ ariaLabel: value });

  const [errors, setErrors] = useState({});


  /**
   * If the user presses Enter or Tab, update the URL
   **/

  const handleKeyDown = useCallback((event) => {
    if ((event.key === 'Enter' || event.key === 'Tab') && link) {
      //handleUrlChange2 is from /deohs_gutenberg_blocks/blocks/utilities/helpers.js
      const updatedUrl = handleUrlChange2(link);
      if (updatedUrl !== link) { // Prevent unnecessary updates
        setAttributes({ link: updatedUrl });
      }
    }
  }, [link, setAttributes]);

  /*
   * For the notice alert of side panel, it must use useEffect instead of validation.js
  */

  useEffect(() => {

    const trimmedLink = link.trim();
    const trimmedTitle = title.trim();
    const trimmedLinkText = linkText.trim();

    setErrors({
      // Only validate link if the user has typed something
      link: trimmedLink ? !isValidDomain(trimmedLink) : false,
      title: !title.trim(),
      profileName: !profileName.trim(),
      linkText: trimmedLink ? !trimmedLinkText : false,
    });
  }, [link, linkText, title, profileName]);




  return (
    <InspectorControls>
      <PanelBody title={t("Profile Card Settings")} initialOpen={true}>
        {/* Profile Name */}
        {errors.profileName && <Notice status="error">{t("Profile name is required")}</Notice>}
        <TextControl
          label={t("Profile Name")}
          value={profileName}
          placeholder={t("Profile Name")}
          required
          onChange={(value) => {
            onChangeProfileName(value);
            setErrors((prev) => ({ ...prev, profileName: !value.trim() }));
          }}
        />

        {/* Profile Title */}
        {errors.title && <Notice status="error">{t("Profile Title is required")}</Notice>}
        <TextareaControl
          label={t("Profile Title")}
          value={title}
          // onChange={onChangeTitle}
          placeholder={t("Profile Title")}
          required
          onChange={(value) => {
            onChangeTitle(value);
            setErrors((prev) => ({ ...prev, title: !value.trim() }));
          }}
        />

        {/* Profile Content */}
        <TextareaControl
          label={t("Profile Content")}
          value={content}
          onChange={onChangeContent}
          placeholder={t("Profile Content")}
        />

        {/* Show Link Toggle */}
        <ToggleControl
          label={t("Show Link")}
          checked={showLink}
          onChange={(value) => setAttributes({ showLink: value })}
        />

        {/* Link Section */}
        {errors.link && <Notice status="error">{t("Valid link URL is required")}</Notice>}
        {showLink && (
          <fieldset className="link-section">
            <legend>{t("Link Settings")}</legend>
            <TextControl
              label={t("Card Link URL")}
              className={errors.link ? "editor-field-error" : ""}
              value={link}
              onChange={onChangeLink}
              onBlur={() => {
                const trimmed = link?.trim();
                if (trimmed) {
                  const updatedUrl = handleUrlChange2(trimmed);
                  if (updatedUrl !== trimmed) {
                    setAttributes({ link: updatedUrl });
                  }
                }
              }}
              onKeyDown={handleKeyDown} // Uses useCallback for efficiency
              placeholder={t("/about or example.com")}
            />

          {errors.linkText && (
            <Notice status="error">{t("CTA text is required when URL is provided")}</Notice>
          )}
          <TextControl
            label={t("Card Link Text")}
            value={linkText}
            onChange={onChangeLinkText}
            placeholder={t("CTA Text")}
            className={errors.linkText ? "editor-field-error" : ""}

          />
          </fieldset>
        )}
      </PanelBody>
      <PanelBody title="Accessibility Settings">
        <TextControl
          label="Aria Label"
          value={ariaLabel || ""}
          onChange={onChangeAriaLabel}
          help="Provide an accessible label for screen readers. This will not be visible but will improve accessibility."
        />
      </PanelBody>
    </InspectorControls>
  );
}

export default ProfileSidePanel;
